
import { Presentation  } from "../../../dev/gameflow/controller/Presentation";
import { SplashController, SplashIndex } from '../../independent/splashScreen/SplashController';
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { GameData } from "../../server/data/BaseModel";
import { RoadRage } from '../../RoadRage';
import { RoadRageEngineManager } from '../../reel/RoadRageEngineManager';

export class BrokeTheBankPresentation extends Presentation {

    public checkForActivation(data: GameData): boolean {
        return !!data.Win.brokeTheBank;
    }

    setGamedData(data: GameData): void {
        SplashController.instance.setData(SplashIndex.BREAKTHEBANK,data);
    }

    preStart(): void { 
        RoadRageEngineManager.preferedLayoutSize = 3;
        RoadRage.backgroundElements.resetRequest();
        
    }

    public createPresentation(enableSkip: Function) {
        enableSkip(false);
        
        if(RoadRage.counter.timeRemaining){
            this.timeline.to(this,{duration:RoadRage.counter.timeRemaining});
            return;
        }

        SlotGame.keypadPlugin.hide(0.25);

        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
        
        this.timeline.add(SplashController.instance.play(SplashIndex.BREAKTHEBANK, true));

        this.PresentationState.setInactive();
    }

    done():void {
        SlotGame.keypadPlugin.show(0.25);
    }
}